import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  TablePagination,
  Autocomplete,
  Backdrop,
  CircularProgress,
  IconButton,
  InputAdornment,
  Icon,
} from "@material-ui/core";
import "./Home.css";
import { viewOnlyStatusforAllPages } from "./viewOnly.js";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { AttachFile, Refresh } from "@material-ui/icons";
import { FormControlLabel } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate, useLocation } from "react-router-dom";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import { Download } from "@material-ui/icons";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import i2pinitiator from "./Excelfiles/i2pinitiator.csv";
import BUTetra from "./Excelfiles/BU-Tetra(1).xlsx";
import jwt from "jsonwebtoken";

import {
  getInvoices,
  getStatusList,
  getUserRoles,
  sendBulkInvoice,
  getInvoicesLandingPage,
} from "./actions";
import { getVendorDetail } from "../Invoices/actions";
import moment from "moment";
import InvoiceTable from "./InvoiceTable";
import NewInvoice from "../Invoices/NewInvoice/NewInvoice";
import {
  aps_Status,
  importStatus,
  initiatorStatus,
  ipStatus,
  irStatus,
  loamStatus,
  logisticStatus,
  status,
  taxTeamStatus,
  depCoordinatorStatus,
  buyerStatus,
  PrInitiatorStatus,
  efdv_Status,
  reviewerStatus,
  lineManagerStatus,
  sharedservices,
  directorHR,
  hrstatus,
  manager_Status,
  gm_Status,
  viewOnlyStatus,
} from "./constant";
import TaxTeamPage from "../Invoices/TaxTeam/TaxTeam";
import ProcessInvoice from "../Invoices/ProcessInvoice/ProcessInvoice";
import { formatDateTimeForBackend } from "../../Functions.js";
import { useDispatch, useSelector } from "react-redux";
import { Role, Status } from "../../Redux/Actions/Role";
import * as XLSX from "xlsx";
import CustomSnackbar from "../../CustomSnackbar";
import LoamInvoice from "../../LoamApprover/LoamInvoice";
import AlertDialog from "./alert";
import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style";
import { makeStyles } from "@material-ui/styles";
import I2pheading from "../../layouts/FullLayout/Header/I2pheading";

const useStyles = makeStyles(dashboardStyle);

const HomePage = () => {
  const classes = useStyles();

  const [data, setData] = useState();
  const [alertList, setAlertList] = useState([]);
  const [statusLoading, setStatusLoading] = useState(true);
  const [statusList, setStatusList] = useState([]);

  const [vendors, setVendors] = useState([]);
  const [vendorLoading, setVendorLoading] = useState(false);

  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);

  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [invoicePayload, setInvoicePayload] = useState({});
  // const [viewInvoice, setViewInvoice] = useState(false);
  const [defaultView, setDefaultView] = useState(true);
  const state = useSelector((state) => state.Role);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);

  // const [showIPPage, setShowIPPage] = useState(false);
  // const [label, setLabel] = useState("");
  const inputRef = useRef(null);
  const [ExcelInvoiceListData, setExcelInvoiceListData] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [isOrderUpdated, setisOrderUpdated] = useState(true);
  const [statusForPayload, setStatusForPayload] = useState("SendToIRFromBuyer");
  const token = localStorage.getItem("user_token");
  const user = jwt.decode(token);
  const dispatch = useDispatch();
  const [formState, setFormState] = useState({
    roleName: state.roleName,
    RoleId: { roleId: state.RoleId },
    Status: state.Status,
    Vendor: {
      Vendor_Code: "-1",
      Vendor_Name: "All",
    },
    SubmissionFromDate: moment().subtract(6, "M").format("YYYY-MM-DD"),
    SubmissionToDate: moment().format("YYYY-MM-DD"),
    // InvoiceFromDate: moment().subtract(6, "M").format("YYYY-MM-DD"),
    // InvoiceToDate: moment().format("YYYY-MM-DD"),
    InvoiceFromDate: "",
    InvoiceToDate: "",
    IsUrgent: false,
    IsSkipTax: false,
    IsVendorFinancing: false,
    IsDifferentVendor: false,
    All: true,
    Generic: "",
    PageNo: 1,
    RowsOfPage: 25,
    OrderBy: "invoice_id",
    isAsc: "false",
  });
  function convertDateFormat(inputDate) {
    var parsedDate = new Date(inputDate);
    var year = parsedDate.getFullYear();
    var month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
    var day = parsedDate.getDate().toString().padStart(2, "0");
    var formattedDate = year + "-" + month + "-" + day + " 00:00:00.0000000";
    return formattedDate;
  }
  const exportToExcel = (data, fileName) => {
    const filteredData = data.filter((item) => {
      return ExcelInvoiceListData.includes(Number(item?.Invoice_Id));
    });

    filteredData.forEach(function (obj) {
      if (obj.hasOwnProperty("Submission Date")) {
        obj["Submission Date"] = convertDateFormat(obj["Submission Date"]);
      }
    });
    if (ExcelInvoiceListData.length > 0) {
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }
  };

  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      roleName: state.roleName,
      RoleId: {
        roleId: state.RoleId,
      },
      Status: state.Status,
    }));
  }, [state]);

  useEffect(() => {
    getVendorDetail(null, setVendors, setVendorLoading);
    // i comment this to check
    // getStatusList(
    //   setStatusList,
    //   setStatusLoading,
    //   state,
    //   state?.roleName,
    //   dispatch
    // );
    getUserRoles(
      setRoles,
      setRolesLoading,
      setStatusList,
      setStatusLoading,
      state,
      dispatch,
      () => {}
    );
  }, []);

  useEffect(() => {
    if (vendors.length > 0 && vendors[0].Vendor_Code !== "-1") {
      const vendorsStrigify = JSON.stringify(vendors);
      const vendorsParse = JSON.parse(vendorsStrigify);
      vendorsParse.unshift({ Vendor_Code: "-1", Vendor_Name: "All" });
      setVendors(vendorsParse);
    }
  }, [vendors]);

  const matches = useMediaQuery("(max-width:700px)");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (location?.state?.msg) {
        const msg = location?.state?.msg;
        const message = typeof msg === "object" ? (msg?.Messages || msg?.message || JSON.stringify(msg)) : msg;
        setSuccessMessage(message);
        navigate(location.pathname, { replace: true });
      }
    }, 2000);
  }, []);
  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        const stringified = JSON.stringify(worksheet);
        const noOfLoops = XLSX.utils.sheet_to_json(worksheet);

        let parse = JSON.parse(stringified);
        sendBulkInvoice(
          parse,
          inputRef,
          formState?.roleName,
          noOfLoops,
          setErrorMessage,
          setSuccessMessage,
          dispatch,
          statusList,
          state,
          setUploadLoading,
          setAlertList,
          setAlertMessage
        );
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
     const updatedFormState = {
      ...formState,
      PageNo: newPage + 1,
    };
     getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        updatedFormState,
        setCount,
        state.Status,
        isOrderUpdated
      );
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));

    //
    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
    // setPage(0);
  };

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
    const updatedFormState = {
      ...formState,
      [name]: value,
    };

    if (
      name === "Vendor" ||
      name === "SubmissionFromDate" ||
      name === "SubmissionToDate" ||
      name === "InvoiceFromDate" ||
      name === "InvoiceToDate"
    ) {
      if(formState.roleName!=="View Only"){
      getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        updatedFormState,
        setCount,
        state.Status,
        isOrderUpdated
      );
    }
    }
  };

  const [count, setCount] = useState(0);
  const getInvoicesLandingPages = () => {
      getInvoicesLandingPage(
      setInvoices,
      setInvoiceLoading,
      formState,
      setCount,
      state.Status,
      isOrderUpdated
    );
  };
  useEffect(() => {
    // getInvoices(setInvoices, setInvoiceLoading, formState, setCount);
    if (formState.roleName !== "View Only") {
      getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
      formState,
      setCount,
      state.Status,
      isOrderUpdated
    );
  }
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState?.Generic,
    formState?.isAsc,
    formState?.OrderBy,
  ]);
  // this useEffect is trigger only when we change role
  useEffect(() => {
    if (!statusLoading) {
      if(formState.roleName!=="View Only"){
      setisOrderUpdated(true);
      getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        formState,
        setCount,
        state.Status,
        isOrderUpdated
      );
    }
    }
  }, [statusLoading, state.Status]);

  const checkBoxHandler = (event) => {
    const { name, checked } = event.target;
    setFormState((formState) => ({
      ...formState,
      All: name === "All" ? true : false,
      IsUrgent: name === "IsUrgent" ? true : false,
      IsSkipTax: name === "IsSkipTax" ? true : false,
      IsVendorFinancing: name === "IsVendorFinancing" ? true : false,
      IsDifferentVendor: name === "IsDifferentVendor" ? true : false,
    }));

    const updatedFormState = {
      ...formState,
      All: name === "All" ? true : false,
      IsUrgent: name === "IsUrgent" ? true : false,
      IsSkipTax: name === "IsSkipTax" ? true : false,
      IsVendorFinancing: name === "IsVendorFinancing" ? true : false,
      IsDifferentVendor: name === "IsDifferentVendor" ? true : false,
    };
    if (
      name === "All" ||
      name === "IsUrgent" ||
      name === "IsSkipTax" ||
      name === "IsVendorFinancing" ||
      name === "IsDifferentVendor"
    ) {
      getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        updatedFormState,
        setCount,
        state.Status,
        isOrderUpdated
      );
    }
  };
  const [visitedInvoices, setVisitedInvoices] = useState(() => {
    const storedVisitedInvoices = localStorage.getItem("visitedInvoices");
    return storedVisitedInvoices ? JSON.parse(storedVisitedInvoices) : [];
  });

  // useEffect(() => {
  //   const handleVisibilityChange = async () => {
  //     if (document.visibilityState === "visible") {
  //       // window.location.reload();
  //       await getUserRoles(
  //         setRoles,
  //         setRolesLoading,
  //         setStatusList,
  //         setStatusLoading,
  //         state,
  //         dispatch,
  //         () => {}
  //       );
  //       getInvoicesLandingPage(
  //         setInvoices,
  //         setInvoiceLoading,
  //         formState,
  //         setCount,
  //         state.Status
  //       );
  //     }
  //   };

  //   // Add event listener for visibility change
  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);
  const RoleName = "IR";
  const invoiceAction = async (invoice) => {
    let pending = "Pending With";
    // Check if the invoice number is not in visitedInvoices array
    // if (!visitedInvoices.includes(invoice["Invoice No"])) {
    //   // Add the invoice number to the visitedInvoices array
    //   setVisitedInvoices([...visitedInvoices, invoice["Invoice No"]]);
    // }
    if (!visitedInvoices.includes(invoice["Invoice No"])) {
      // Add the invoice number to the visitedInvoices array
      const updatedInvoices = [...visitedInvoices, invoice["Invoice No"]];
      setVisitedInvoices(updatedInvoices);

      // Store the updated visitedInvoices array in localStorage
      localStorage.setItem("visitedInvoices", JSON.stringify(updatedInvoices));

      // Store the updated visitedInvoices array in localStorage
      localStorage.setItem(
        "visitedInvoices",
        JSON.stringify([...visitedInvoices, invoice["Invoice No"]])
      );
    }
    if (
      (taxTeamStatus[invoice.Status] === true ||
        taxTeamStatus[invoice.Status] === false) &&
      state.roleName === "Tax Team"
    ) {
      if (taxTeamStatus[invoice.Status] === true) {
        window.open(
          `/#/taxCheck?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${taxTeamStatus[invoice.Status]}`,
          "_blank"
        );
      } else {
        window.open(
          `/#/taxteamdetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${taxTeamStatus[invoice.Status]}`,
          "_blank"
        );
      }
    } else if (
      (depCoordinatorStatus[invoice.Status] === true ||
        depCoordinatorStatus[invoice.Status] === false) &&
      state.roleName === "Department Coordinator"
    ) {
      if (depCoordinatorStatus[invoice.Status] === true) {
        window.open(
          `/#/departmentCoordinator?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${
            depCoordinatorStatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/departmentDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${
            depCoordinatorStatus[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (ipStatus[invoice.Status] === true ||
        ipStatus[invoice.Status] === false) &&
      state.roleName === "IP"
    ) {
      if (ipStatus[invoice.Status] === true) {
        window.open(
          `/#/processInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${ipStatus[invoice.Status]}`,
          "_blank"
        );
      } else {
        window.open(
          `/#/processInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${ipStatus[invoice.Status]}`,
          "_blank"
        );
      }
    } else if (
      (loamStatus[invoice.Status] === true ||
        loamStatus[invoice.Status] === false) &&
      state.roleName === "Loam Approver"
    ) {
      if (loamStatus[invoice.Status] === true) {
        window.open(
          `/#/loamApprover?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${loamStatus[invoice.Status]}`,
          "_blank"
        );
      } else {
        window.open(
          `/#/LoamDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${loamStatus[invoice.Status]}`,
          "_blank"
        );
      }
    } else if (
      (irStatus[invoice.Status] === true ||
        irStatus[invoice.Status] === false) &&
      state.roleName === "IR"
    ) {
      if (irStatus[invoice.Status] === true) {
        window.open(
          `/#/invoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            irStatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        if (invoice[pending]) {
          if (
            user.UserName === invoice[pending] &&
            invoice["Status"] === "SendToIP" &&
            state.roleName === "IP"
          ) {
            window.open(
              `/#/processInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=IP&roleId=013fa4f6-3525-434b-8293-c1a72ef1526f&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=true`,
              "_blank"
            );
          } else if (
            user.UserName === invoice[pending] &&
            invoice["Status"] === "SendToTaxTeam"
          ) {
            window.open(
              `/#/taxCheck?invoiceId=${invoice?.Invoice_Id}&roleName=Tax Team&roleId=02e4e743-9a83-46b3-933f-bac372c52e49&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=true`,
              "_blank"
            );
          } else if (
            user.UserName === invoice[pending] &&
            invoice["Status"] === "SendToDeptCoordinator"
          ) {
            window.open(
              `/#/departmentCoordinator?invoiceId=${invoice?.Invoice_Id}&roleName=Department Coordinator&roleId=3a662fad-f1b0-499c-a33d-bd6dd94d96f2&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=true`,
              "_blank"
            );
          } else if (
            user.UserName === invoice[pending] &&
            invoice["Status"] === "SendToSupervisor"
          ) {
            window.open(
              `/#/APS_Invoice?invoiceId=${invoice?.Invoice_Id}&roleName=AP Supervisor&&roleId=828b9b2a-7b55-4c42-8f2c-1a073e300f2c&&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=true`
              // "_blank"
            );
          } else if (
            user.UserName === invoice[pending] &&
            invoice["Status"] === "SendToReviewer"
          ) {
            window.open(
              `/#/reviwerInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=Reviewer&roleId=99b64e17-4c95-4a38-a217-32142b141ff8&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=edit`,
              "_blank"
            );
          } else {
            window.open(
              `/#/NewInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
                state.roleName
              }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
                irStatus[invoice.Status]
              }`,
              "_blank"
            );
          }
        } else {
          window.open(
            `/#/NewInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
              state.roleName
            }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
              irStatus[invoice.Status]
            }`,
            "_blank"
          );
        }
      }
    } else if (
      (initiatorStatus[invoice.Status] === true ||
        initiatorStatus[invoice.Status] === false) &&
      state.roleName === "I2P Initiator"
    ) {
      if (initiatorStatus[invoice.Status] === true) {
        window.open(
          `/#/newInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            initiatorStatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/NewInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            initiatorStatus[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (importStatus[invoice.Status] === true ||
        importStatus[invoice.Status] === false) &&
      state.roleName === "Import"
    ) {
      if (importStatus[invoice.Status] === true) {
        window.open(
          `/#/newInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            importStatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/NewInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            importStatus[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (aps_Status[invoice.Status] === true ||
        aps_Status[invoice.Status] === false) &&
      state.roleName === "AP Supervisor"
    ) {
      if (aps_Status[invoice.Status] === true) {
        window.open(
          `/#/APS_Invoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&vendorCode=${
            invoice?.["Vendor Code"]
          }&edit=${aps_Status[invoice.Status]}`
          // "_blank"
        );
      } else {
        window.open(
          `/#/APS_InvoiceDetailPage?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&vendorCode=${
            invoice?.["Vendor Code"]
          }&edit=${aps_Status[invoice.Status]}`
          // "_blank"
        );
      }
    } else if (
      (manager_Status[invoice.Status] === true ||
        manager_Status[invoice.Status] === false) &&
      state.roleName === "AP Manager"
    ) {
      window.open(
        `/#/APS_Invoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&status=${invoice?.Status}&vendorCode=${
          invoice?.["Vendor Code"]
        }&edit=${manager_Status[invoice.Status]}`,
        "_blank"
      );
    } else if (
      (gm_Status[invoice.Status] === true ||
        gm_Status[invoice.Status] === false) &&
      state.roleName === "AP GM"
    ) {
      window.open(
        `/#/APS_Invoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&status=${invoice?.Status}&vendorCode=${
          invoice?.["Vendor Code"]
        }&edit=${gm_Status[invoice.Status]}`,
        "_blank"
      );
    } else if (
      (logisticStatus[invoice.Status] === true ||
        logisticStatus[invoice.Status] === false) &&
      state.roleName === "Logistic"
    ) {
      window.open(
        `/#/logisticsInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&&vendorCode=${
          invoice?.["Vendor Code"]
        }&status=${invoice?.Status}&edit=${logisticStatus[invoice.Status]}`,
        "_blank"
      );
    } else if (
      (buyerStatus[invoice.Status] === true ||
        buyerStatus[invoice.Status] === false) &&
      state.roleName === "Buyer"
    ) {
      window.open(
        `/#/buyerInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&status=${invoice.Status}&edit=${
          buyerStatus[invoice.Status]
        }`,
        "_blank"
      );
    } else if (
      (PrInitiatorStatus[invoice.Status] === true ||
        PrInitiatorStatus[invoice.Status] === false) &&
      state.roleName === "PR Initiator"
    ) {
      window.open(
        `/#/prInitiatorInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&status=${invoice.Status}&edit=${
          PrInitiatorStatus[invoice.Status]
        }`,
        "_blank"
      );
    } else if (
      (reviewerStatus[invoice.Status] === true ||
        reviewerStatus[invoice.Status] === false) &&
      state.roleName === "Reviewer"
    ) {
      if (reviewerStatus[invoice.Status] === true) {
        if (invoice[pending]) {
          if (user.UserName === invoice[pending]) {
            window.open(
              `/#/reviwerInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
                state.roleName
              }&roleId=${state.RoleId}&vendorCode=${
                invoice?.["Vendor Code"]
              }&status=${invoice.Status}&edit=${
                reviewerStatus[invoice.Status]
              }`,
              "_blank"
            );
          } else if (user.UserName !== invoice[pending]) {
            window.open(
              `/#/reviwerInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${state.roleName}&roleId=${state.RoleId}&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=false`,
              "_blank"
            );
          }
        } else if (invoice["Status"] === "SendToReviewerFromSupervisor"||invoice["Status"] === "SendToReviewerFromManager"||invoice["Status"] === "SendToReviewerFromGM") {
          window.open(
            `/#/reviwerInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${state.roleName}&roleId=${state.RoleId}&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=true`,
            "_blank"
          );
        }else if((invoice["Status"] === "SendToReviewerFromIP" || invoice["Status"] === "SendToReviewerFromIR") && invoice["PO Number"]!==""){
            window.open(`/#/processInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${state.roleName}&roleId=${state.RoleId}&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=false`)        
        } else {
          window.open(
            `/#/reviwerInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
              state.roleName
            }&roleId=${state.RoleId}&vendorCode=${
              invoice?.["Vendor Code"]
            }&status=${invoice.Status}&edit=${reviewerStatus[invoice.Status]}`,
            "_blank"
          );
        }
      } else {
        window.open(
          `/#/reviwerInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&vendorCode=${
            invoice?.["Vendor Code"]
          }&status=${invoice.Status}&edit=${reviewerStatus[invoice.Status]}`,
          "_blank"
        );
      }
    } else if (
      (efdv_Status[invoice.Status] === true ||
        efdv_Status[invoice.Status] === false) &&
      state.roleName === "EFDV Initiator"
    ) {
      window.open(
        `/#/invoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
          state.roleName
        }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
          efdv_Status[invoice.Status]
        }`,
        "_blank"
      );
    } else if (
      (lineManagerStatus[invoice.Status] === true ||
        lineManagerStatus[invoice.Status] === false) &&
      state.roleName === "Line Manager"
    ) {
      if (lineManagerStatus[invoice.Status] === true) {
        window.open(
          `/#/LineManager?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            lineManagerStatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/LineManagerDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            lineManagerStatus[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (sharedservices[invoice.Status] === true ||
        sharedservices[invoice.Status] === false) &&
      state.roleName === "Shared Services"
    ) {
      if (sharedservices[invoice.Status] === true) {
        window.open(
          `/#/SharedServices?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            sharedservices[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/SharedServicesDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            sharedservices[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (directorHR[invoice.Status] === true ||
        directorHR[invoice.Status] === false) &&
      state.roleName === "Director HR"
    ) {
      if (directorHR[invoice.Status] === true) {
        window.open(
          `/#/DirectorHR?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            directorHR[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/DirectorHRDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            directorHR[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (
      (hrstatus[invoice.Status] === true ||
        hrstatus[invoice.Status] === false) &&
      state.roleName === "HR"
    ) {
      if (hrstatus[invoice.Status] === true) {
        window.open(
          `/#/newInvoice?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            hrstatus[invoice.Status]
          }`,
          "_blank"
        );
      } else {
        window.open(
          `/#/NewInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&edit=${
            hrstatus[invoice.Status]
          }`,
          "_blank"
        );
      }
    } else if (state.roleName === "View Only") {
      if (viewOnlyStatus[invoice.Status] === true) {
        window.open(
          `/#/APS_InvoiceDetailPage?invoiceId=${invoice?.Invoice_Id}&roleName=${
            state.roleName
          }&roleId=${state.RoleId}&status=${invoice?.Status}&vendorCode=${
            invoice?.["Vendor Code"]
          }&edit=${aps_Status[invoice.Status]}`,
          "_blank"
        );
      } else {
        let userId = state.RoleId;
        let userrole = state.roleName;
        let pageUrl = await viewOnlyStatusforAllPages(
          invoice,
          state.roleName,
          state.RoleId,
          roles
        );
        console.log(pageUrl);
        window.open(`${pageUrl}`, "_blank");
      }
    }
    setInvoicePayload(invoice);
  };

  // const taxCheckGoBack = () => {
  //   setDefaultView(true);
  //   setShowTaxTeamPage(false);
  // };
  // const newInvoiceFun = () => {
  //   setDefaultView(false);
  //   setShowNewInvoice(true);
  // };

  // const goBackToLandingPage = () => {
  //   setDefaultView(true);
  //   setShowNewInvoice(false);
  //   setViewInvoice(false);
  //   setShowIPPage(false);
  // };
  const refreshInvoices = () => {
    if (formState?.isAsc === "false" && formState?.OrderBy === "invoice_id") {
      getInvoicesLandingPage(
        setInvoices,
        setInvoiceLoading,
        formState,
        setCount,
        state.Status,
        isOrderUpdated
      );
    } else {
      setFormState(() => ({
        ...formState,
        OrderBy: "invoice_id",
        isAsc: "false",
      }));
    }
  };


  console.log(statusList, "statusList")
  return (
    <>
      {defaultView ? (
        <>
          {/* <I2pheading /> */}
          <Card
            className="scrollable"
            style={{
              margin: "0px 20px",
              backgroundColor: "#EFF2F4",
              boxShadow: "none",
            }}>
            <CardHeader text>
              <CardText
                style={{
                  padding: "0px 27px",
                  backgroundColor: "#031C30",
                  color: "white",
                }}>
                <Grid container justifyContent="space-between">
                  <Grid item xs={2} sm={3} md={3} lg={3}>
                    <h1 style={{ fontSize: "18px" }}>Home Page</h1>
                  </Grid>
                </Grid>
              </CardText>
            </CardHeader>
            <CardBody>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={6} md={2}>
                  <Typography> Status:</Typography>
                  <Autocomplete
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "30px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInputBase-input": {
                        marginTop: "-4px", // Adjust this value to move the text up
                        fontSize: 15,
                      },
                    }}
                    id="selectStatus"
                    options={statusList?.filter((item)=>item?.text !== "Admin")}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Status"
                    // value={{Status: (state?.Status || statusList[0])}}
                    value={formState?.Status || ""}
                    getOptionLabel={(option) =>
                      (option !== "" && `${option?.text || ""}`) || ""
                    }
                    loading={statusLoading}
                    onChange={(event, newValue) => {
                      dispatch(Status(newValue));
                      autocompleteChangeHandler("Status", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={3} xs={6}>
                  <Typography> Vendor:</Typography>
                  <Autocomplete
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "30px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInputBase-input": {
                        marginTop: "-4px", // Adjust this value to move the text up
                        fontSize: 15,
                      },
                    }}
                    id="Vendor"
                    options={vendors}
                    classes={{ option: classes.option }}
                    size="small"
                    name="Vendor"
                    value={formState.Vendor}
                    getOptionLabel={(option) =>
                      (option !== "" &&
                        `${
                          option?.Vendor_Code !== "-1"
                            ? `${option?.Vendor_Code}-`
                            : ""
                        }${option?.Vendor_Name}`) ||
                      ""
                    }
                    loading={vendorLoading}
                    onChange={(event, newValue) => {
                      autocompleteChangeHandler("Vendor", newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        onChange={(event) => {
                          getVendorDetail(
                            event.target.value,
                            setVendors,
                            setVendorLoading
                          );
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  <Typography> Role:</Typography>
                  <Autocomplete
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "30px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInputBase-input": {
                        marginTop: "-4px", // Adjust this value to move the text up
                        fontSize: 15,
                      },
                    }}
                    id="RoleId"
                    options={roles}
                    size="small"
                    classes={{ option: classes.option }}
                    name="RoleId"
                    value={{ roleName: formState?.roleName || "" }}
                    getOptionLabel={(option) =>
                      (option !== "" && `${option?.roleName}`) || ""
                    }
                    loading={rolesLoading}
                    onChange={(event, newValue) => {
                      // autocompleteChangeHandler("RoleId", newValue);
                      // autocompleteChangeHandler("roleName", newValue?.roleName);
                      setFormState((formState) => ({
                        ...formState,
                        RoleId: newValue,
                        roleName: newValue?.roleName,
                      }));
                      setInvoiceLoading(true);
                      setInvoices([]);
                      getStatusList(
                        setStatusList,
                        setStatusLoading,
                        state,
                        newValue?.roleName,
                        dispatch
                      );
                      dispatch(Role(newValue));
                    }}
                    renderInput={(params) => (
                      <TextField
                        // sx={{ input: { color: "#888888" } }}
                        {...params}
                        name=""
                        required
                        value={""}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={5} lg={5}>
                  {/* Bulk Invoice upload */}
                  {(formState.roleName === "IR" ||
                    formState.roleName === "I2P Initiator" ||
                    formState.roleName === "Department Coordinator") && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        border: "2px solid #454f58",
                        padding: "25px 20px",
                      }}>
                      <IconButton size="small">
                        <Tooltip title="Download Excel File">
                          {formState.roleName === "I2P Initiator" ||
                          formState.roleName === "Department Coordinator" ? (
                            <a href={i2pinitiator}>
                              <Download
                                titleAccess="Download"
                                fontSize="small"
                                color="info"
                              />
                            </a>
                          ) : (
                            <a href={BUTetra}>
                              <Download
                                titleAccess="Download"
                                fontSize="small"
                                color="info"
                              />
                            </a>
                          )}
                        </Tooltip>
                      </IconButton>
                      <hr
                        style={{
                          margin: "0px",
                          height: "20px",
                          marginTop: "4px",
                        }}
                      />
                      <Button variant="text" size="small" color="secondary">
                        <input
                          id="raised-button-file"
                          type="file"
                          name="upload"
                          ref={inputRef}
                          accept=".xlsx,.csv"
                          style={{ display: "none" }}
                          onChange={readUploadFile}
                        />
                        <label
                          htmlFor="raised-button-file"
                          style={{ color: "black" }}>
                          Bulk Invoice Upload
                        </label>
                      </Button>
                    </div>
                  )}
                </Grid>
                {(formState.roleName === "IR" ||
                  formState.roleName === "I2P Initiator" ||
                  formState.roleName === "Import" ||
                  formState.roleName === "EFDV Initiator" ||
                  formState.roleName === "Department Coordinator" ||
                  formState.roleName === "HR") && (
                  <Grid item md={2} xs={12} style={{ paddingTop: "3px" }}>
                    <Link to="/newInvoice" target="_blank">
                      <Button
                        variant="contained"
                        size="large"
                        color="secondary"
                        sx={{
                          padding: "3px 4%",
                          width: "-webkit-fill-available",
                        }}
                        // onClick={newInvoiceFun}
                        // onClick={() => navigate("/newInvoice")}
                      >
                        NEW INVOICE
                      </Button>
                    </Link>
                  </Grid>
                )}
                <Grid
                  item
                  md={
                    formState.roleName === "IR" ||
                    formState.roleName === "I2P Initiator" ||
                    formState.roleName === "Import" ||
                    formState.roleName === "EFDV Initiator" ||
                    formState.roleName === "HR" ||
                    formState.roleName === "Department Coordinator"
                      ? 10
                      : 12
                  }
                  xs={12}
                  style={{
                    paddingTop: "3px",
                    marginTop: `${
                      formState.roleName === "IR" ||
                      formState.roleName === "I2P Initiator" ||
                      formState.roleName === "Import" ||
                      formState.roleName === "EFDV Initiator" ||
                      formState.roleName === "HR" ||
                      formState.roleName === "Department Coordinator"
                        ? "0px"
                        : "25px"
                    }`,
                  }}>
                  <Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    sx={{
                      padding: "3px 4%",
                    }}
                    disabled={ExcelInvoiceListData.length === 0}
                    // onClick={newInvoiceFun}
                    onClick={() => {
                      exportToExcel(invoices, "Invoices");
                    }}>
                    Export to excel
                  </Button>
                  {formState?.roleName === 'View Only' ? (<Button
                    variant="contained"
                    size="large"
                    color="secondary"
                    sx={{
                      padding: "3px 4%",
                      marginLeft: "10px",
                    }}
                    onClick={getInvoicesLandingPages}
                  >
                    Search
                  </Button>):null}
                </Grid>
                <Grid
                  item
                  md={2}
                  xs={12}
                  style={{ paddingRight: "15px", marginTop: "-12px" }}>
                  <Typography>Submission Date:</Typography>
                  <input
                    className={`${classes.inputField} ${classes.inputFieldStyle}`}
                    name="SubmissionFromDate"
                    type="date"
                    max="9999-12-31"
                    value={formState.SubmissionFromDate}
                    onChange={(e) =>
                      autocompleteChangeHandler(
                        "SubmissionFromDate",
                        e.target.value,
                        formatDateTimeForBackend(e)
                      )
                    }
                    style={{ height: 12 }}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  xs={12}
                  style={{ paddingRight: "15px", marginTop: "-12px" }}>
                  <Typography>Submission End Date:</Typography>
                  <input
                    className={`${classes.inputField} ${classes.inputFieldStyle}`}
                    name="SubmissionToDate"
                    type="date"
                    max="9999-12-31"
                    value={formState.SubmissionToDate}
                    onChange={(e) =>
                      autocompleteChangeHandler(
                        "SubmissionToDate",

                        e.target.value,
                        formatDateTimeForBackend(e)
                      )
                    }
                    style={{ height: 12 }}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  xs={12}
                  style={{ paddingRight: "15px", marginTop: "-12px" }}>
                  <Typography>Invoice Start Date:</Typography>
                  <input
                    className={`${classes.inputField} ${classes.inputFieldStyle}`}
                    name="InvoiceFromDate"
                    type="date"
                    max="9999-12-31"
                    value={formState.InvoiceFromDate}
                    onChange={(e) =>
                      autocompleteChangeHandler(
                        "InvoiceFromDate",
                        e.target.value,
                        formatDateTimeForBackend(e)
                      )
                    }
                    style={{ height: 12 }}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  xs={12}
                  style={{ paddingRight: "15px", marginTop: "-12px" }}>
                  <Typography>Invoice End Date:</Typography>
                  <input
                    className={`${classes.inputField} ${classes.inputFieldStyle}`}
                    name="InvoiceToDate"
                    type="date"
                    max="9999-12-31"
                    value={formState.InvoiceToDate}
                    onChange={(e) =>
                      autocompleteChangeHandler(
                        "InvoiceToDate",

                        e.target.value,
                        formatDateTimeForBackend(e)
                      )
                    }
                    style={{ height: 12 }}
                  />
                  {/*<LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={formState.InvoiceToDate}
                    onChange={(newValue) => {
                      autocompleteChangeHandler(
                        "InvoiceToDate",
                        formatDateTimeForBackend(newValue)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        fullWidth
                        id="outlined-basic"
                        label="Outlined"
                        variant="outlined"
                        {...params}
                        onChange={(e) =>
                          autocompleteChangeHandler(
                            "InvoiceToDate",
                            e.target.value
                          )
                        }
                        error={false}
                      />
                    )}
                  />
                 </LocalizationProvider>*/}
                </Grid>
              </Grid>
              {/* <Grid container spacing={2} mt={1}>
                <Grid item md={2} xs={12} style={{ paddingRight: "15px" }}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={() => {
                      exportToExcel(invoices, "Invoices");
                    }}
                  >
                    Export to excel
                  </Button>
                </Grid> 
              </Grid>*/}
            </CardBody>
          </Card>
          <Card
            className="scrollable"
            style={{
              margin: "0px 38px",
              boxShadow: "rgba(164, 196, 226, 0.6) 2px 5px 10px 1px",
            }}>
            <CardBody>
              <div style={{ backgroundColor: "#FFFFFF" }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={5} lg={4}>
                    {/* <Typography>Search by keyword</Typography> */}

                    <TextField
                      placeholder="Enter keyword..."
                      sx={{
                        "& .MuiInputBase-root": {
                          height: 30,
                        },
                      }}
                      fullWidth={true}
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      type="text"
                      name="Generic"
                      value={formState.Generic}
                      onChange={(e) => {
                        setFormState((formState) => ({
                          ...formState,
                          Generic: e.target.value,
                        }));
                      }}
                      style={{ marginTop: "-20px" }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchOutlinedIcon sx={{ color: "#0095DA" }} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  {/* Check boxes */}
                  <Grid
                    style={{ marginTop: "-25px" }}
                    item
                    xs={12}
                    sm={12}
                    md={7}
                    lg={7}>
                    <FormControlLabel
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      // style={{ marginLeft: "3px" }}
                      label="All"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          checked={formState.All}
                          name="All"
                          onChange={(event) => {
                            checkBoxHandler(event);
                            // setFormState((formState) => ({
                            //   ...formState,
                            //   All: event.target.checked,
                            // }));
                          }}
                        />
                      }
                    />
                    <FormControlLabel
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      // style={{ marginLeft: "3px" }}
                      label="Urgent"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          style={{
                            color: "#FFCCCB",
                          }}
                          checked={formState.IsUrgent}
                          name="IsUrgent"
                          onChange={(event) => {
                            checkBoxHandler(event);
                          }}
                        />
                      }
                    />
                    <FormControlLabel
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      // style={{ marginLeft: "3px" }}
                      label="Skip Tax Team"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          style={{
                            color: "#3799",
                          }}
                          checked={formState.IsSkipTax}
                          name="IsSkipTax"
                          onChange={(event) => {
                            checkBoxHandler(event);
                          }}
                        />
                      }
                    />

                    <FormControlLabel
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      // style={{ marginLeft: "3px" }}
                      label="Vendor Financing"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          style={{
                            color: "rgb(7, 177, 111, 0.48)",
                          }}
                          checked={formState.IsVendorFinancing}
                          name="IsVendorFinancing"
                          onChange={(event) => {
                            checkBoxHandler(event);
                          }}
                        />
                      }
                    />
                    <FormControlLabel
                      style={{
                        padding: "0px",
                        margin: "0px",
                      }}
                      // style={{ marginLeft: "3px" }}
                      // label="Different Vendor" // this keyword is change in payload by saleem after some time
                      label=" Different Vendor"
                      color="secondary"
                      control={
                        <Checkbox
                          color="secondary"
                          fontSize="small"
                          style={{
                            color: "#ff9d5c",
                          }}
                          checked={formState.IsDifferentVendor}
                          name="IsDifferentVendor"
                          onChange={(event) => {
                            checkBoxHandler(event);
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={12} mt={-6}>
                    <IconButton
                      size="sm"
                      sx={{ float: "right" }}
                      onClick={refreshInvoices}>
                      <Refresh />
                    </IconButton>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={0}
                  mt={1}
                  style={{ overflowX: "auto" }}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ width: "0" }}
                  >
                     <TablePagination
                  rowsPerPageOptions={[25, 50, 100, 500, 1000]}
                  component="div"
                  count={count}
                  rowsPerPage={formState.RowsOfPage}
                  page={parseInt(formState.PageNo) - 1}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                    <InvoiceTable
                      invoiceList={invoices}
                      loading={invoiceLoading}
                      invoiceAction={invoiceAction}
                      formState={formState}
                      setFormState={setFormState}
                      visitedInvoices={visitedInvoices}
                      setErrAlertMessage={setErrorMessage}
                      setExcelInvoiceListData={setExcelInvoiceListData}
                      setisOrderUpdated={setisOrderUpdated}
                    />
                  </Grid>
                </Grid>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100, 500, 1000]}
                  component="div"
                  count={count}
                  rowsPerPage={formState.RowsOfPage}
                  page={parseInt(formState.PageNo) - 1}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </CardBody>
          </Card>
        </>
      ) : (
        ""
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}
      {alertMessage && (
        <AlertDialog Alert={alertList} setAlertMessage={setAlertMessage} />
      )}

      {uploadLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={uploadLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {/* {viewInvoice ? (
        <NewInvoice
          label={label}
          goBackToLandingPage={goBackToLandingPage}
          roles={roles}
          rolesLoading={rolesLoading}
          invoicePayload={invoicePayload}
          role={formState.RoleId}
        />
      ) : (
        ""
      )}

      {showTaxTeamPage && (
        <TaxTeamPage
          invoicePayload={invoicePayload}
          role={formState.RoleId}
          taxCheckGoBack={taxCheckGoBack}
        />
      )}

      {showNewInvoice && (
        <NewInvoice
          label="Add New Invoice"
          goBackToLandingPage={goBackToLandingPage}
          roles={roles}
          rolesLoading={rolesLoading}
          // role={formState.RoleId}
        />
      )}
      {showIPPage && (
        <ProcessInvoice
          goBackToLandingPage={goBackToLandingPage}
          roles={roles}
          rolesLoading={rolesLoading}
          invoicePayload={invoicePayload}
          role={formState.RoleId}
        />
      )} */}
    </>
  );
};

export default HomePage;
